"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newToLegacy = void 0;
var newToLegacyMappings = [
    {
        source: 'INDUSTRY',
        type: 'ACTUAL',
        lifecycle: 'INLIFE',
        legacyReadType: 'OnSiteReading',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ACTUAL',
        lifecycle: 'CHANGE_OF_SUPPLY_OPENING',
        legacyReadType: 'OpeningReadingActual',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ACTUAL',
        lifecycle: 'CHANGE_OF_SUPPLY_CLOSING',
        legacyReadType: 'FinalReadingActual',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ACTUAL',
        lifecycle: 'FINAL',
        legacyReadType: 'MeterConfigChangeFinal',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ACTUAL',
        lifecycle: 'INITIAL',
        legacyReadType: 'MeterConfigChangeInitial',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ACTUAL',
        lifecycle: 'INSTALL',
        legacyReadType: 'MexReadingInitial',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ACTUAL',
        lifecycle: 'REMOVAL',
        legacyReadType: 'MexReadingFinal',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ESTIMATE',
        lifecycle: 'INLIFE',
        legacyReadType: 'EstimatedReading',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ESTIMATE',
        lifecycle: 'CHANGE_OF_SUPPLY_OPENING',
        legacyReadType: 'OpeningReadingDeemed',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ESTIMATE',
        lifecycle: 'CHANGE_OF_SUPPLY_CLOSING',
        legacyReadType: 'FinalReadingDeemed',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ESTIMATE',
        lifecycle: 'INITIAL',
        legacyReadType: 'MeterConfigChangeInitialEstimated',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ESTIMATE',
        lifecycle: 'FINAL',
        legacyReadType: 'MeterConfigChangeFinalEstimated',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ESTIMATE',
        lifecycle: 'INSTALL',
        legacyReadType: 'MexReadingInitialEstimated',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'INDUSTRY',
        type: 'ESTIMATE',
        lifecycle: 'REMOVAL',
        legacyReadType: 'MexReadingFinalEstimated',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'MANUAL_READ_CUSTOMER',
        type: 'ACTUAL',
        lifecycle: 'INLIFE',
        legacyReadType: 'CustomerSubmittedReading',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'SMART_METER',
        type: 'ACTUAL',
        lifecycle: 'INLIFE',
        legacyReadType: 'SmartReading',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ACTUAL',
        lifecycle: 'INLIFE',
        legacyReadType: 'CorrectionReadActual',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ESTIMATE',
        lifecycle: 'INLIFE',
        legacyReadType: 'CorrectionReadEstimate',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'MIGRATION',
        type: 'ACTUAL',
        lifecycle: 'CHANGE_OF_SUPPLY_OPENING',
        legacyReadType: 'MigrationReadingActual',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'MIGRATION',
        type: 'ESTIMATE',
        lifecycle: 'CHANGE_OF_SUPPLY_OPENING',
        legacyReadType: 'MigrationReadingEstimated',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: true,
    },
    {
        source: 'SMART_METER',
        type: 'ACTUAL',
        lifecycle: 'CHANGE_OF_SUPPLY_OPENING',
        legacyReadType: 'OpeningReadingActual',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'SMART_METER',
        type: 'ACTUAL',
        lifecycle: 'CHANGE_OF_SUPPLY_CLOSING',
        legacyReadType: 'FinalReadingActual',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ACTUAL',
        lifecycle: 'CHANGE_OF_SUPPLY_OPENING',
        legacyReadType: 'OpeningReadingActual',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ACTUAL',
        lifecycle: 'CHANGE_OF_SUPPLY_CLOSING',
        legacyReadType: 'FinalReadingActual',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ACTUAL',
        lifecycle: 'FINAL',
        legacyReadType: 'MeterConfigChangeFinal',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ACTUAL',
        lifecycle: 'INITIAL',
        legacyReadType: 'MeterConfigChangeInitial',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ACTUAL',
        lifecycle: 'INSTALL',
        legacyReadType: 'MexReadingInitial',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ACTUAL',
        lifecycle: 'REMOVAL',
        legacyReadType: 'MexReadingFinal',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ESTIMATE',
        lifecycle: 'CHANGE_OF_SUPPLY_OPENING',
        legacyReadType: 'OpeningReadingDeemed',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ESTIMATE',
        lifecycle: 'CHANGE_OF_SUPPLY_CLOSING',
        legacyReadType: 'FinalReadingDeemed',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ESTIMATE',
        lifecycle: 'INITIAL',
        legacyReadType: 'MeterConfigChangeInitialEstimated',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ESTIMATE',
        lifecycle: 'FINAL',
        legacyReadType: 'MeterConfigChangeFinalEstimated',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ESTIMATE',
        lifecycle: 'INSTALL',
        legacyReadType: 'MexReadingInitialEstimated',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
    {
        source: 'MANUAL_READ_AGENT',
        type: 'ESTIMATE',
        lifecycle: 'REMOVAL',
        legacyReadType: 'MexReadingFinalEstimated',
        isNewToLegacyMapping: true,
        isLegacyToNewMapping: false,
    },
];
var newToLegacy = function (source, newType, lifecycle) {
    var _a;
    return (_a = newToLegacyMappings.find(function (newMapping) {
        return (newMapping.source === source &&
            newMapping.type === newType &&
            newMapping.lifecycle === lifecycle);
    })) === null || _a === void 0 ? void 0 : _a.legacyReadType;
};
exports.newToLegacy = newToLegacy;
